// extracted by mini-css-extract-plugin
export default {"userSelect":"CrmSelect_userSelect__Dt7Z7"};